import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=42f93bc8&scoped=true&lang=pug&"
import script from "./CustomerList.vue?vue&type=script&lang=ts&"
export * from "./CustomerList.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=42f93bc8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f93bc8",
  null
  
)

export default component.exports